<template>
    <div class="sing-up">
        <b-form @submit="singUp" class="sing-up-form text-center">
            <h3 class="title">Sign Up</h3>
            <b-form-group>
              <b-form-input type="text" v-model="name" placeholder="Your name" required></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input type="password" v-model="password" placeholder="Your password" minlength="8" required></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input type="email" v-model="email" placeholder="Your email" required></b-form-input>
            </b-form-group>
            <b-form-group class="sign-up-datepicker">
              <b-form-input
                  style="position: absolute;z-index: -1"
                  :value="convertDataToString(date)"
                  required
              />
              <Datepicker
                  bootstrap-styling
                  v-model="date"
                  placeholder="Company start date"
                  format="dd/MM/yyyy"
              />
            </b-form-group>
            <b-form-group>
              <multiselect
                v-model="roles"
                placeholder="Your role"
                tag-placeholder="select roles"
                :options="_allUserRoles"
                track-by="id"
                label="display_name"
                :multiple="true"
                :showLabels="false"
                />
            </b-form-group>
            <b-button
              class="button ml-auto"
              type="submit"
              variant="primary"
            >
              Sign Up
            </b-button>
        </b-form>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'singup',
  components: { Datepicker },
  data () {
    return {
      name: '',
      password: '',
      email: '',
      date: '',
      roles: []
    }
  },
  methods: {
    convertDataToString (value) {
      if (value) return value.toString()
    },
    singUp (e) {
      e.preventDefault()
      var roleIds = []
      this.roles.forEach(function (role) {
        roleIds.push(role.id)
      })
      this.axios
        .post('/api/register', {
          name: this.name,
          password: this.password,
          email: this.email,
          date: this._toLocalTime(this.date),
          roles: roleIds
        })
        .then(response => {
          console.log(response)
          this.name = ''
          this.email = ''
          this.password = ''
          this.roles = []

          this.$router.push('/singin')
          this.$snotify.success(response.statusText, 'Success', this.$store.state.snotify)
        })
        .catch(err => {
          this.$snotify.error(err.response.data.error, 'Error', this.$store.state.snotify)
          console.log(err.response.data)
        })
    }
  }

}
</script>

<style lang="scss">
.sing-up{
  display: flex;
  justify-content: center;
}
.sign-up-datepicker{
  position: relative;
  margin-bottom: 20px;
  .form-control[readonly] {
    background-color: transparent;
  }
}
.sing-up-form{
    width: 320px;
}

.sing-up-form h3{
    margin-bottom: 20px;
}
</style>
